export default __webpack_public_path__ + "static/media/Your story.90440ceb.svg";